import firebase from 'firebase';
import 'firebase/firestore';
import { initializeApp } from 'firebase/app';
// danish imoprts 
// import { getAuth } from "firebase/auth"

const config = {
    apiKey: "AIzaSyDn9LoEkY8_4yM7wAJnC0EkXqOGTUyv358",
    authDomain: "rrr-web-d0aca.firebaseapp.com",
    projectId: "rrr-web-d0aca",
    storageBucket: "rrr-web-d0aca.appspot.com",
    // databaseURL: "https://tactical-snow-275301.firebaseio.com"
  };

  firebase.initializeApp(config);
  export const auth = firebase.auth;
  export const db = firebase.database();
  export const fs = firebase.firestore();
  export const fbStorage = firebase.storage();
  // Test review for the firebase call
  // const app = initializeApp(config);
  // export const myOth = firebase.auth(app);
  //export const testdb = firebase.database().ref();

